import {
  RESET_SUPPORT_TEAM,
  RESET_SUPPORT_TEAM_CHANGE,
  UPDATE_SUPPORT_TEAM_CHANGE,
  UPDATE_SUPPORT_TEAM,
  FETCH_SUPPORT_TEAM,
  FETCH_SUPPORT_TEAM_START,
  FETCH_SUPPORT_TEAM_SUCCESS,
  FETCH_SUPPORT_TEAM_ERROR,
  POST_SUPPORT_TEAM,
  POST_SUPPORT_TEAM_START,
  POST_SUPPORT_TEAM_SUCCESS,
  POST_SUPPORT_TEAM_ERROR,
} from './constants'

const resetSupportTeam = () => ({ type: RESET_SUPPORT_TEAM })
const resetSupportTeamChange = () => ({ type: RESET_SUPPORT_TEAM_CHANGE })
const updateSupportTeam = (team) => ({ type: UPDATE_SUPPORT_TEAM, team })
const updateSupportTeamChange = (team, role) => ({ type: UPDATE_SUPPORT_TEAM_CHANGE, team, role })
const fetchSupportTeam = (projectId) => ({ type: FETCH_SUPPORT_TEAM, projectId })
const fetchSupportTeamStart = () => ({ type: FETCH_SUPPORT_TEAM_START })
const fetchSupportTeamSuccess = (team) => ({ type: FETCH_SUPPORT_TEAM_SUCCESS, team })
const fetchSupportTeamError = (error) => ({ type: FETCH_SUPPORT_TEAM_ERROR, error })
const postSupportTeam = (projectId) => ({ type: POST_SUPPORT_TEAM, projectId })
const postSupportTeamStart = () => ({ type: POST_SUPPORT_TEAM_START })
const postSupportTeamSuccess = () => ({ type: POST_SUPPORT_TEAM_SUCCESS })
const postSupportTeamError = (error) => ({ type: POST_SUPPORT_TEAM_ERROR, error })

export {
  resetSupportTeam,
  resetSupportTeamChange,
  updateSupportTeam,
  updateSupportTeamChange,
  fetchSupportTeam,
  fetchSupportTeamStart,
  fetchSupportTeamSuccess,
  fetchSupportTeamError,
  postSupportTeam,
  postSupportTeamStart,
  postSupportTeamSuccess,
  postSupportTeamError,
}
